import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 3v12h-5c-.023 -3.681 .184 -7.406 5 -12m0 12v6h-1v-3m-10 -14v17m-3 -17v3a3 3 0 1 0 6 0v-3","key":"svg-0"}]]

/**
 * IconToolsKitchen2
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdG9vbHMta2l0Y2hlbi0yIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xOSAzdjEyaC01Yy0uMDIzIC0zLjY4MSAuMTg0IC03LjQwNiA1IC0xMm0wIDEydjZoLTF2LTNtLTEwIC0xNHYxN20tMyAtMTd2M2EzIDMgMCAxIDAgNiAwdi0zIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/tools-kitchen-2
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconToolsKitchen2 = createReactComponent('outline', 'tools-kitchen-2', 'ToolsKitchen2', __iconNode);

export default IconToolsKitchen2;